import React, { Component } from 'react';
import * as firebase from 'firebase';
import Wrap from './Layout/Wrap';

const config = {
  apiKey: "AIzaSyC6jZZQHlkoLwVUz96aldIVb9zQAYU8Uvo",
  authDomain: "herbal-cure.firebaseapp.com",
  databaseURL: "https://herbal-cure.firebaseio.com",
  projectId: "herbal-cure",
  storageBucket: "herbal-cure.appspot.com",
  messagingSenderId: "968108696541"
};
firebase.initializeApp(config);

export default class Jrouter extends Component {
  render() {
    return(
       <Wrap config />
    )
  }
}



// WEBPACK FOOTER //
// ./src/Jrouter.js